import classes from "./ApplicationBankCard.module.css";
import { Button, Tag } from "antd";
import { IApplicationBankCardProps } from "../../../interfaces/props/Application/IApplicationBankCardProps/IApplicationBankCardProps";

export const ApplicationBankCard = ({
  className = "",
  isActive,
  status,
  bankName,
  onShow,
  children,
  childrenContainerProps,
  ...restProps
}: IApplicationBankCardProps) => {
  const concatClassName = `${classes.applicationBankCard} ${
    isActive ? classes.active : ""
  } ${className}`;
  return (
    <div className={concatClassName} {...restProps}>
      <div className={classes.bankInfo}>
        <p className={classes.bankName}>{bankName}</p>
        <p className={classes.bankStatus}>
          <Tag className={classes.bankStatusTag} color={status.color}>
            {status.title}
          </Tag>
        </p>
      </div>

      <div {...childrenContainerProps}>
        {children}
        <Button
          onClick={onShow}
          className={classes.showBtn}
          type="link"
          variant={"outlined"}
        >
          Посмотреть
        </Button>
      </div>
    </div>
  );
};
